import React from "react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Box,
  Button,
  Field,
  FieldLabel,
  Input,
} from "@salestrak/ui";
import { resetPassword } from "#app/lib/auth-service";
import { useLocalSearchParams, useRouter } from '#app/lib/hooks/router-compat';

export function ResetPasswordForm() {
  const { token } = useLocalSearchParams<{ token: string }>();
  const router = useRouter();
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const submit = async () => {
    setError("");
    if (!password.trim()) {
      setError("Password is required.");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    if (!token) {
      setError("Invalid or missing reset token.");
      return;
    }
    setIsLoading(true);
    try {
      await resetPassword(token, password);
      router.replace("/(auth)/login");
    } catch (err: any) {
      setError(err.message ?? "Reset failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    void submit();
  };

  return (
    <Box as="form" direction="column" gap="xl" onSubmit={handleSubmit}>
      <Box direction="column" gap="sm">
        <Field>
          <FieldLabel>New Password</FieldLabel>
          <Input
            type="password"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            autoComplete="new-password"
            disabled={isLoading}
          />
        </Field>

        <Field>
          <FieldLabel>Confirm Password</FieldLabel>
          <Input
            type="password"
            placeholder="Confirm password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            disabled={isLoading}
          />
        </Field>
      </Box>

      {error ? (
        <Alert variant="error">
          <AlertTitle>Unable to reset password</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      ) : null}

      <Button type="submit" loading={isLoading}>
        Reset password
      </Button>
    </Box>
  );
}
